import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/entities-to-logs/')({
  beforeLoad: ({ context, preload }) => {
    const path = PAGE_PATHS.ENTITIES_TO_LOGS;
    const isAllowed = context.userPermissions.hasAllowedPermission({ path });
    context.validatePermissions({ isAllowed, preload });
  },
});
